// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"77060fdb","183":"3b4b2859","686":"c990395d","702":"3bee258c","914":"89be5aa6"}[chunkId] + ".chunk.js";
};